<template>
  <page-loader>
    <v-container>
      <v-row no-gutters>
        <v-col class="d-flex align-center">
          <v-spacer />

          <search-input v-model="query.searchTerm" :disabled="hasPageErrors" hide-details />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <offers-list
            :is-loading="isLoading"
            :items="filteredPartners"
            link="links"
            type="partner"
            :pagination="pagination"
            async
            @page-change="onPageChange"
          />
        </v-col>
      </v-row>
    </v-container>
  </page-loader>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import PageLoader from '@/components/page-loader'
import SearchInput from '@/components/forms/search-input'

import QueryParamsHandler from '@/mixins/query-params-handler'

import { partners } from '@/services/offers'

import OffersList from '@/views/offers/components/offers-list'

export default {
  name: 'LinksManagement',
  components: {
    OffersList,
    PageLoader,
    SearchInput,
  },
  mixins: [QueryParamsHandler],
  data: () => ({
    partners: [],
    searchKey: 'name',
  }),
  computed: {
    ...mapGetters('general', ['hasPageErrors']),
    filteredPartners() {
      return this.partners.filter(({ name }) => {
        return !this.query.searchTerm || name.toLowerCase().includes(this.query.searchTerm.toLowerCase())
      })
    },
  },
  async created() {
    await this.getPartners()
    this.setPageLoading(false)
  },
  methods: {
    ...mapMutations('general', ['setPageLoading', 'setPageErrors']),
    async getPartners() {
      this.isLoading = true

      try {
        const { perPage, currentPage: page } = this.pagination

        const { data, pagination } = await partners.getAllPartners({
          compact: true,
          page,
          perPage,
          filters: this.queryFilters,
        })
        this.partners = data
        this.pagination = pagination
        this.pagination.perPage = 20
      } catch (error) {
        this.setPageErrors(true)
        this.$notify({
          type: 'error',
          text: 'Unable to retrieve partners',
        })
      }

      this.isLoading = false
    },
    async onPageChange(page) {
      this.pagination.currentPage = page
      await this.getPartners()
    },
    async handleQueryUpdate() {
      await this.getPartners()
    },
  },
}
</script>
